import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dashboard-tutorial-slide',
  templateUrl: 'dashboard-tutorial-slide.html',
})
export class DashboardTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public dishServices: DishServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_dashboard = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_dashboard': this.globals.restaurant.tutorial_dashboard,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave() {
    this.globals.restaurant.tutorial_dashboard = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_dashboard': this.globals.restaurant.tutorial_dashboard,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/dashboard-tutorial-slide/dashboard-tutorial-slide.ts